module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-ThinItalic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-ThinItalic.eot
// module id = 15
// module chunks = 8